<template>
  <div id="oficio-autorizacion-default" class="bkground">
    <!-- Estado cargando -->
    <template v-if="cargando">
      <v-row>
        <v-col cols="12" md="4">
          <v-skeleton-loader type="card"></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="8">
          <v-skeleton-loader type="card, card"></v-skeleton-loader>
        </v-col>
      </v-row>
    </template>

    <!-- Contenido -->
    <template v-else>
      <v-row>
        <!-- Columna izquierda: Información general -->
        <v-col cols="12" md="4">
          <!-- Card Información -->
          <v-card class="rounded-lg mb-4">
            <v-card-title class="grey darken-3 white--text text-subtitle-1 py-3">
              <v-icon left small color="white">mdi-file-document-outline</v-icon>
              Información General
            </v-card-title>
            <v-card-text class="pt-4">
              <v-list dense class="transparent">
                <v-list-item class="px-0">
                  <v-list-item-icon class="mr-3">
                    <v-icon small color="grey">mdi-calendar</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-caption">
                      Fecha del Oficio
                    </v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ formatearFecha(oficio.fecha) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="px-0">
                  <v-list-item-icon class="mr-3">
                    <v-icon small color="grey">mdi-inbox-arrow-down</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-caption">
                      Fecha Recibido
                    </v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ fechaRecibidoFormateada }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="px-0">
                  <v-list-item-icon class="mr-3">
                    <v-icon small :color="getColorVencimiento">mdi-clock-alert</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-caption">
                      Fecha Vencimiento
                    </v-list-item-subtitle>
                    <v-list-item-title :class="getClaseVencimiento">
                      {{ fechaVencimientoFormateada }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="px-0">
                  <v-list-item-icon class="mr-3">
                    <v-icon small color="grey">mdi-update</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-caption">
                      Última actualización
                    </v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ formatearFechaHora(oficio.updatedAt) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>

          <!-- Card Resumen Financiero -->
          <v-card class="rounded-lg">
            <v-card-title class="grey darken-3 white--text text-subtitle-1 py-3">
              <v-icon left small color="white">mdi-currency-usd</v-icon>
              Resumen Financiero
            </v-card-title>
            <v-card-text class="pt-4">
              <!-- Totales principales -->
              <v-row class="text-center mb-4">
                <v-col cols="12">
                  <div class="pa-3 rounded-lg" style="background: rgba(0,0,0,0.02);">
                    <div class="text-caption grey--text mb-1">Importe Total</div>
                    <div class="text-h6 font-weight-bold primary--text">
                      {{ oficio.importe | currency }}
                    </div>
                  </div>
                </v-col>
              </v-row>

              <v-row class="text-center mb-4">
                <v-col cols="6">
                  <div class="pa-3 rounded-lg success lighten-5">
                    <div class="text-caption grey--text mb-1">Asignado</div>
                    <div class="text-subtitle-1 font-weight-bold success--text">
                      {{ importeAsignado | currency }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div
                    class="pa-3 rounded-lg"
                    :class="importePendiente > 0 ? 'warning lighten-5' : 'success lighten-5'">
                    <div class="text-caption grey--text mb-1">Pendiente</div>
                    <div
                      class="text-subtitle-1 font-weight-bold"
                      :class="importePendiente > 0 ? 'warning--text' : 'success--text'">
                      {{ importePendiente | currency }}
                    </div>
                  </div>
                </v-col>
              </v-row>

              <!-- Barra de progreso -->
              <v-progress-linear
                :value="porcentajeAsignado"
                :color="getColorProgreso"
                height="20"
                rounded
                class="mb-2">
                <template v-slot:default>
                  <span class="white--text text-caption font-weight-bold">
                    {{ porcentajeAsignado.toFixed(1) }}%
                  </span>
                </template>
              </v-progress-linear>

              <div class="text-center">
                <v-chip
                  small
                  :color="getColorProgreso"
                  text-color="white">
                  {{ getTextoEstadoAsignacion }}
                </v-chip>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Columna derecha: Recursos asignados -->
        <v-col cols="12" md="8">
          <v-card class="rounded-lg">
            <v-card-title class="grey darken-3 white--text text-subtitle-1 py-3">
              <v-icon left small color="white">mdi-format-list-bulleted</v-icon>
              Recursos Asignados
              <v-chip
                x-small
                color="white"
                text-color="grey darken-3"
                class="ml-2">
                {{ getDetalles.length }}
              </v-chip>
              <v-spacer></v-spacer>
              <v-btn
                v-if="mixValidaScopesActions(1) && importePendiente > 0"
                x-small
                color="white"
                text
                @click="agregarRecurso">
                <v-icon left x-small>mdi-plus</v-icon>
                Agregar
              </v-btn>
            </v-card-title>
            <v-card-text class="pa-0">
              <!-- Sin detalles -->
              <template v-if="getDetalles.length === 0">
                <div class="text-center py-10">
                  <v-icon size="60" color="grey lighten-2">
                    mdi-file-document-outline
                  </v-icon>
                  <p class="text-body-1 grey--text mt-4 mb-0">
                    No hay recursos asignados
                  </p>
                  <v-btn
                    v-if="mixValidaScopesActions(1)"
                    small
                    color="primary"
                    class="mt-4"
                    @click="agregarRecurso">
                    <v-icon left small>mdi-plus</v-icon>
                    Agregar primer recurso
                  </v-btn>
                </div>
              </template>

              <!-- Lista de detalles -->
              <v-list v-else two-line class="py-0">
                <div v-for="(detalle, index) in getDetalles" :key="detalle.id">
                  <v-list-item class="recurso-item">
                    <v-list-item-avatar>
                      <v-avatar color="primary" size="40">
                        <v-icon dark small>mdi-domain</v-icon>
                      </v-avatar>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        {{ getClaveObra(detalle) }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="text-wrap">
                        {{ getMetaObra(detalle) }}
                      </v-list-item-subtitle>
                      <div class="d-flex align-center mt-1">
                        <v-chip
                          x-small
                          outlined
                          class="mr-2"
                          v-if="detalle.fuenteFinanciera">
                          {{ detalle.fuenteFinanciera.origen }}
                        </v-chip>
                        <span
                          class="text-caption grey--text"
                          v-if="detalle.clavePresupuestal">
                          {{ detalle.clavePresupuestal }}
                        </span>
                      </div>
                    </v-list-item-content>

                    <v-list-item-action>
                      <div class="d-flex align-center">
                        <span class="font-weight-bold primary--text mr-4">
                          {{ detalle.importe | currency }}
                        </span>
                        <v-btn
                          v-if="mixValidaScopesActions(3)"
                          icon
                          small
                          color="error"
                          @click="eliminarDetalle(detalle)">
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    v-if="index < getDetalles.length - 1"
                    inset>
                  </v-divider>
                </div>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <!-- Diálogo Agregar Recurso -->
    <v-dialog
      v-if="mostrarAgregarRecurso"
      v-model="mostrarAgregarRecurso"
      persistent
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
      <registrar-nuevo-detalle
        :oficio="oficio"
        :sumaDetalles="importeAsignado"
        @cerrar="mostrarAgregarRecurso = false">
      </registrar-nuevo-detalle>
    </v-dialog>

    <!-- Diálogo Eliminar Detalle -->
    <v-dialog
      v-if="mostrarEliminarDetalle"
      v-model="mostrarEliminarDetalle"
      persistent
      width="450">
      <eliminar-detalle
        :oficioAutorizacionDetalleEliminar="detalleAEliminar"
        @cerrar="cerrarEliminarDetalle">
      </eliminar-detalle>
    </v-dialog>
  </div>
</template>

<script>
import RegistrarNuevoDetalle from '@/components/administracion/programacion/oficiosautorizacion/oficiosautorizaciondetalle/Nuevo.vue';
import EliminarDetalle from '@/components/administracion/programacion/oficiosautorizacion/oficiosautorizaciondetalle/Eliminar.vue';

export default {
  name: 'OficioAutorizacionDefault',
  components: {
    RegistrarNuevoDetalle,
    EliminarDetalle,
  },
  props: {
    oficio: {
      type: Object,
      default: () => ({}),
    },
    cargando: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mostrarAgregarRecurso: false,
      mostrarEliminarDetalle: false,
      detalleAEliminar: null,
    };
  },
  filters: {
    currency(value) {
      if (!value && value !== 0) return '$0.00';
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
      }).format(value);
    },
  },
  computed: {
    getDetalles() {
      if (!this.oficio?.detalles) return [];
      return this.oficio.detalles;
    },
    importeAsignado() {
      return this.getDetalles.reduce((sum, d) => sum + (d.importe || 0), 0);
    },
    importePendiente() {
      return (this.oficio.importe || 0) - this.importeAsignado;
    },
    porcentajeAsignado() {
      if (!this.oficio.importe || this.oficio.importe === 0) return 0;
      return (this.importeAsignado / this.oficio.importe) * 100;
    },
    getColorProgreso() {
      if (this.porcentajeAsignado >= 100) return 'success';
      if (this.porcentajeAsignado >= 75) return 'info';
      if (this.porcentajeAsignado >= 50) return 'warning';
      return 'error';
    },
    getTextoEstadoAsignacion() {
      if (this.porcentajeAsignado >= 100) return 'Completamente asignado';
      if (this.porcentajeAsignado >= 75) return 'Casi completo';
      if (this.porcentajeAsignado >= 50) return 'En progreso';
      if (this.porcentajeAsignado > 0) return 'Parcialmente asignado';
      return 'Sin asignar';
    },
    getColorVencimiento() {
      if (!this.oficio.fechaVencimiento) return 'grey';
      const hoy = new Date();
      const vencimiento = new Date(this.oficio.fechaVencimiento);
      const dias = Math.ceil((vencimiento - hoy) / (1000 * 60 * 60 * 24));
      if (dias < 0) return 'error';
      if (dias <= 7) return 'warning';
      return 'success';
    },
    getClaseVencimiento() {
      const color = this.getColorVencimiento;
      if (color === 'error') return 'error--text font-weight-bold';
      if (color === 'warning') return 'white--text';
      return '';
    },
    fechaRecibidoFormateada() {
      if (!this.oficio.fechaRecibido) return 'No registrada';
      return this.formatearFecha(this.oficio.fechaRecibido);
    },
    fechaVencimientoFormateada() {
      if (!this.oficio.fechaVencimiento) return 'No registrada';
      return this.formatearFecha(this.oficio.fechaVencimiento);
    },
  },
  methods: {
    formatearFecha(fecha) {
      if (!fecha) return '';
      return new Date(`${fecha}T00:00:00`).toLocaleDateString('es-MX', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },
    formatearFechaHora(fecha) {
      if (!fecha) return '';
      return new Date(fecha).toLocaleString('es-MX', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
    getClaveObra(detalle) {
      return detalle?.obraSolicitada?.obra?.clave || 'Sin clave';
    },
    getMetaObra(detalle) {
      return detalle?.obraSolicitada?.obra?.meta || 'Sin descripción';
    },
    agregarRecurso() {
      this.mostrarAgregarRecurso = true;
    },
    eliminarDetalle(detalle) {
      this.detalleAEliminar = detalle;
      this.mostrarEliminarDetalle = true;
    },
    cerrarEliminarDetalle() {
      this.mostrarEliminarDetalle = false;
      this.detalleAEliminar = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.recurso-item {
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.02);
  }
}
</style>
